import { getTopsales } from '@backmarket/http-api/src/api-specs-navigation-experience/navigation/topsales'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'

export function useTopSales() {
  return useHttpFetch(getTopsales)
}
